module.exports = __webpack_public_path__ + "static/media/pmt_enter-payments-adjustments-entry.5e4aad02.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/pmt_enter-payments-adjustments-entry.md
// module id = 1104
// module chunks = 0